import { useState } from "react";
import { Box, Button, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import { mockDataContacts } from "../../data/mockData"; // Initially imported data
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";

const Contacts = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // State to manage the rows
  const [rows, setRows] = useState(mockDataContacts);
  const [open, setOpen] = useState(false); // State to control the dialog
  const [selectedRow, setSelectedRow] = useState(null); // State to hold selected row data

  // Function to handle row deletion
  const handleDelete = (id) => {
    const updatedRows = rows.filter((row) => row.id !== id); // Filter out the row to be deleted
    setRows(updatedRows); // Update the rows state with the filtered data
  };

  const handleEdit = (id) => {
    console.log("Edit row with ID:", id);
    // Add your edit logic here
  };

  // Function to handle view icon click and open popup
  const handleView = (row) => {
    setSelectedRow(row); // Set the clicked row data
    setOpen(true); // Open the dialog
  };

  // Function to close the popup dialog
  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 0.5 },
    { field: "registrarId", headerName: "Registrar ID" },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "age",
      headerName: "Age",
      type: "number",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "phone",
      headerName: "Phone Number",
      flex: 1,
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
    },
    {
      field: "address",
      headerName: "Address",
      flex: 1,
    },
    {
      field: "city",
      headerName: "City",
      flex: 1,
    },
    {
      field: "zipCode",
      headerName: "Zip Code",
      flex: 1,
    },
    // Edit, View, and Delete actions
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return (
          <Box>
            {/* View Icon */}
            <IconButton onClick={() => handleView(params.row)}>
              <VisibilityIcon style={{ color: colors.greenAccent[500] }} />
            </IconButton>

            {/* Edit Icon */}
            <IconButton onClick={() => handleEdit(params.row.id)}>
              <EditIcon style={{ color: colors.blueAccent[600] }} />
            </IconButton>

            {/* Delete Icon */}
            <IconButton onClick={() => handleDelete(params.row.id)}>
              <DeleteIcon style={{ color: colors.redAccent[600] }} />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  return (
    <Box m="20px">
      <Header title="PG Management" subtitle="List of PG Management Details" />
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        {/* Add Button */}
        <Box display="flex" justifyContent="flex-end" mb={2}>
          <Button variant="contained" color="primary" sx={{ marginTop: "20px" }}>
            Add Farmer
          </Button>
        </Box>

        <DataGrid
          rows={rows}  // Updated to use state rows
          columns={columns}
          components={{ Toolbar: GridToolbar }}
        />

        {/* View Row Dialog */}
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Farmer Management</DialogTitle>
          <DialogContent>
            {selectedRow && (
              <>
                <Typography><strong>ID:</strong> {selectedRow.id}</Typography>
                <Typography><strong>Registrar ID:</strong> {selectedRow.registrarId}</Typography>
                <Typography><strong>Name:</strong> {selectedRow.name}</Typography>
                <Typography><strong>Age:</strong> {selectedRow.age}</Typography>
                <Typography><strong>Phone:</strong> {selectedRow.phone}</Typography>
                <Typography><strong>Email:</strong> {selectedRow.email}</Typography>
                <Typography><strong>Address:</strong> {selectedRow.address}</Typography>
                <Typography><strong>City:</strong> {selectedRow.city}</Typography>
                <Typography><strong>Zip Code:</strong> {selectedRow.zipCode}</Typography>
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">Close</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
};

export default Contacts;
